export default __webpack_public_path__ + "static/media/banner.12a86899.jpg";